import React, { useRef, useState,useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
function Executive() {
    const iframeRef = useRef(null);
    const [showIframe, setShowIframe] = useState(false);
    const [path, setPathnameURL] = useState('');
    useEffect(() => {
        var pathnameurl = window.location.pathname.split('/')[2];
        const regEx = new RegExp('-', "g");
        const resultName = pathnameurl.replace(regEx, ' ');
        setPathnameURL(resultName);
    })
    const handleChange = () => {
        document.getElementById('iframeDiv').style.display = "block";

        if (iframeRef.current) {
            iframeRef.current.scrollIntoView({ behavior: 'smooth' });
        }

    }
    const handleYesClick = (e) => {
        e.preventDefault();
        setShowIframe(true);
    }

    const handleNoClick = (e) => {
        e.preventDefault();
        setShowIframe(false);
    }
    return (
        <>
            <section>
            <Container>
                    <Row>
                        <Col>
                            <ul className="navigator-arrow">
                                <li><a href="/" aria-label="Home"><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li><a href="/AboutUs/Teams"><i>AboutUs</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                {window.location.pathname != "" ? <li>{path.replace('/','')}</li> : ''}
                            </ul>
                        </Col>
                    </Row>
                </Container>
                <div className='footer-link-data'>
                    <h1>Executive Remuneration</h1>
                </div>
                <Container>
                    <div className='vision-main'>
                        {/* <div className='section-header'>
                            <h2>Executive Remuneration</h2>

                        </div> */}
                        <div className='vision-detail'>
                            <Row>
                               
                                <Col sm={12} md={12}>
                                    <div className='vision-data'>


                                        <p>SEBI vide its circular no. SEBI/HO/IMD/DF2/CIR/P/2016/42 dated March 18, 2016 has mandated that Executive
                                            Remuneration* be disclosed to investors, the underlying objective being transparency in remuneration policies
                                            so that executive remuneration is aligned with the interest of Mutual Fund investors.
                                            In accordance with the above, the remuneration details of the executives of JM Financial Mutual Fund who
                                            fulfil the specified criteria in the above circular, for the previous year are being disclosed.</p>
                                        <p>
                                            * Remuneration shall mean remuneration as defined in clause (78) of section 2 of the Companies Act, 2013.
                                        </p>
                                        <p>
                                            To enable you to view the Executive Remuneration, we request you to confirm as under:
                                        </p>
                                        <p>
                                            1.	I/We hereby declare that I/we am/are an existing investor(s) in the scheme(s) of JM Financial Mutual Fund.
                                        </p>
                                        <p>
                                            2.	I/We hereby declare that the details provided by me/us are true and correct.
                                        </p>
                                        <p>
                                            3.	I/We understand that the remuneration details provided are sensitive and personal and are being furnished strictly on my/our specific request for the same.
                                        </p>
                                        <p>
                                            4.	I/We understand that, the data provided herein is not to be modified or used in any way including for construction of any kind of database, or mirrored at any other location.
                                        </p>
                                        <p>
                                            5.	I/We understand that, no part of this data is to be reproduced, shared, published, distributed, displayed, copied or stored
                                            in any information retrieval system, or transmitted in any form by any means whatsoever, including electronically
                                            or digitally on the Internet or World Wide Web, or over any network.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row>
                        <Col sm={12} md={12}>
                            <div className='vision-data'>
                                <p>I agree to the terms :
                                    <a href="#" className="achrTerm" onClick={handleYesClick} id="achrTermY">Yes</a>
                                    &nbsp;&nbsp;
                                    <a href="#" className="achrTerm" onClick={handleNoClick} id="achrTermN">No</a>
                                </p>
                                <p>
                                    {showIframe && (
                                        <div className="frame" id="iframeDiv" ref={iframeRef}>
                                            <iframe id="ifrRemuneration" src="https://mfs.kfintech.com/jmfremuneration/executiveremuneration.aspx" width="100%" height="100%"></iframe>
                                        </div>
                                    )}

                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
}

export default Executive;
